import { useRef } from '@max/max';
import { mtShare } from '@max/meituan-uni-mtShare';
import { WX_MINI_APP, WX_MINI_APP_RAW_ID } from './types';
// import Tools from '@nibfe/mp-webview-tools';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { isMiniProgramOrWebview, isTitansAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from '@nibfe/mkt-env-api';
import { ShareType } from './types';
import { navigateTo } from '@max/meituan-uni-navigate';
import { appendParams, convertLinkToAppMiddleOpenLink } from '../../utils/url';
import { useQRCodePopup } from '../useQRCodePopup';
export function useShare() {
    const pikeConnected = useRef(false);
    const ctx = useMonitorEngineContext();
    const queryParams = ctx._runtimeInfo?.queryParams || {};
    const { openQRCodePopup } = useQRCodePopup();
    const isInApp = isTitansAppOrWebview();
    const isInWX = isWeixinMiniProgramOrWeixinWebview();
    const isInWxMiniProgram = isWeixinMiniProgramOrWeixinWebview() && isMiniProgramOrWebview();
    const isInWxWebview = isWeixinMiniProgramOrWeixinWebview() && !isMiniProgramOrWebview();
    async function shareWXCard(options) {
        const { params = {}, wxMiniApp = WX_MINI_APP.HOTEL, onSuccess, shareConfig } = options || {};
        const { shareUrl, shareContent, shareTitle, shareImg, shareType } = shareConfig || {};
        const url = appendParams(shareUrl || '', {
            isFromShare: 'true',
            ...params
        });
        if (shareType === ShareType.QR_CODE) {
            openQRCodePopup(url);
            return;
        }
        if (shareType === ShareType.CALL_LINK) {
            if (isInWX) {
                openQRCodePopup(url);
            }
            else {
                await mtShare({
                    type: 0,
                    content: shareContent || '分享内容',
                    title: shareTitle || '分享标题',
                    imageUrl: shareImg || '',
                    url: convertLinkToAppMiddleOpenLink(url)
                });
                onSuccess?.();
            }
            return;
        }
        if (shareType === ShareType.H5_LINK) {
            if (isInApp) {
                await mtShare({
                    type: 0,
                    content: shareContent || '分享内容',
                    title: shareTitle || '分享标题',
                    imageUrl: shareImg || '',
                    url
                });
                onSuccess?.();
            }
            if (isInWxMiniProgram) {
                openQRCodePopup(url);
            }
            else if (isInWxWebview) {
                navigateTo({
                    url: convertLinkToAppMiddleOpenLink(url)
                });
            }
            else {
                navigateTo({
                    url: convertLinkToAppMiddleOpenLink(url)
                });
            }
            return;
        }
        if (isInApp) {
            const appId = WX_MINI_APP_RAW_ID[wxMiniApp];
            let path = '';
            switch (wxMiniApp) {
                case WX_MINI_APP.MT:
                    path = `/hotel/pages/h5/index?q=${encodeURIComponent(url)}`;
                    break;
                case WX_MINI_APP.HOTEL:
                    path = `/pages/h5/index?q=${encodeURIComponent(url)}`;
                    break;
                default:
                    ctx._uiInteractionAPI.toast.show({
                        content: '分享失败，请稍后重试～'
                    });
                    return;
            }
            await mtShare({
                type: 1,
                appId,
                path,
                url,
                content: shareContent || '分享内容',
                title: shareTitle || '分享标题',
                imageUrl: shareImg
            });
            onSuccess?.();
        }
        else {
            ctx._raptorReport.monitorReportLog?.('分享失败', '环境异常', {
                level: 'warn',
                category: 'mcp-use-monitor',
                tags: {
                    name: '分享失败'
                }
            });
            ctx._uiInteractionAPI.toast.show({
                content: '请在美团App或微信内打开'
            });
        }
    }
    return {
        shareWXCard
    };
}
